import { useEffect } from 'react'
import { Objectclass } from '@yes.technology/react-toolkit'

import fetchObjectclass from '../api/fetchObjectclass'
import { useQuery } from '@tanstack/react-query'

export type UseObjectclassArgs = {
  objectclassUuid?: string | null | undefined
  enabled?: boolean
}

export default function useObjectclass({
  objectclassUuid,
  enabled = true
}: UseObjectclassArgs) {
  const { data, error, isLoading, isFetched } = useQuery<
    Objectclass | null,
    Error
  >({
    queryKey: ['objectclass', objectclassUuid],
    queryFn: () => fetchObjectclass(objectclassUuid, false),
    enabled: enabled && !!objectclassUuid
  })

  useEffect(() => {
    if (error) console.log(error.message)
  }, [error])

  return {
    objectclass: data || undefined,
    isFetched,
    isLoading,
    error
  }
}
